export default __webpack_public_path__ + "static/media/hamster.ab141a45.png";